import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutColumn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayoutColumn"><Path d="M20.5 3.5H21.05V2.95H20.5V3.5ZM20.5 20.5V21.05H21.05V20.5H20.5ZM3.5 20.5H2.95V21.05H3.5V20.5ZM3.5 3.5V2.95H2.95V3.5H3.5ZM19.95 3.5V20.5H21.05V3.5H19.95ZM20.5 19.95H3.5V21.05H20.5V19.95ZM4.05 20.5V3.5H2.95V20.5H4.05ZM3.5 4.05H20.5V2.95H3.5V4.05Z" fill="currentColor"/><Path d="M11.45 3.5V20.5H12.55V3.5H11.45Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutColumn;
